"use strict";

exports.__esModule = true;
exports.CreatedAtSection = CreatedAtSection;
var _react = _interopRequireDefault(require("react"));
var _FormattedPlantDate = require("../../Time/FormattedPlantDate");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _excluded = ["created"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function CreatedAtSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var created = props.created,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, _extends({}, extra, {
    heading: translate("TicketDetails.created", "Created At"),
    content: /*#__PURE__*/_react["default"].createElement(_FormattedPlantDate.FormattedPlantDate, {
      formatOptions: {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      },
      value: created
    })
  }));
}